import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
import svgCompassOuterRing from "cesium-navigation-es6/svgPaths/svgCompassOuterRing";
const root = {}
export default root
root.name = 'processDangerTaskTroubleshoot';
root.props = {
	cacheData: Object,
	callBack: Function,
	eployeeData: Array,
}
root.data = {
	//tab页默认页数
	thisTable: 0,

	//协同人名称
	employeeNames: "",

	//是否显示弹出框
	showModal: false,

	//检查标准
	dangerTaskCheckTableTitle: [{
			title: '编号',
			key: 'checkNo'
		},
		{
			title: '大类/中类/小类',
			key: 'bigMidSmall'
		},
		{
			title: '检查项目',
			key: 'checkProject'
		},
		{
			title: '检查标准',
      key: 'checkStand',
      tooltip: true
		},
		{
			title: '检查方法',
			key: 'checkMethod',
		},
		{
			title: '排查描述',
      slot: 'description',
      tooltip: true
		},
		{
			title: '排查结果',
			slot: 'pass',
		},
		{
			title: '治理',
			slot: 'governance',
		},
		{
			title: '图片',
			slot: 'img',
		},
		{
			title: '操作',
			slot: 'action',
		}
	],

	operaHiddenData: {
		taskHiddenDangerVo: {
			pass: 0
		},
	},
	imagesBase64:[]
}

root.methods = {

	isInspectionCompleted: function(hiddenDanger) {
		const status = hiddenDanger && hiddenDanger.isCheck;
		return status === 1 || status === '1' || status === true;
	},

	action: function(row, index) {
    // console.log(row)
		this.showModal = true;
		this.operaHiddenData = { ...row};
		this.operaHiddenData.index= index;
		this.operaHiddenData.taskHiddenDangerVo = { ...row.taskHiddenDangerVo};
	},

	//开始排查
	startTroubles: function() {
		const that = this;
		const data = {};
		data.hiddenDangerId = this.operaHiddenData.id;
		data.troubleshootPlanId = this.cacheData.id;
		data.description = this.operaHiddenData.taskHiddenDangerVo.description;
		data.pass = this.operaHiddenData.taskHiddenDangerVo.pass;
		data.id = this.operaHiddenData.taskHiddenDangerVo.id
		data.isCheck = 1
		this.componentsMoudel.startPost("/troubleshoottask/troubleshootOne", data, true).then(res => {
			const thisTroubleshootPlan = { ...that.cacheData};
			thisTroubleshootPlan.checkStandardVos[that.operaHiddenData.index].taskHiddenDangerVo = res.body.data;
			thisTroubleshootPlan.taskHiddenDangerVo = res.body.data;
			that.callBack(thisTroubleshootPlan);
			that.modalCancle();
		})
	},

	//创建隐患治理
	createGrovern: function(row, index) {
		const that = this;
		const data = {};
		data.bigMidSmall = JSON.stringify(row.hiddenIds);
		data.taskHiddenDangerId = row.taskHiddenDangerVo.id;
		data.taskNum = this.cacheData.taskNum;
		this.componentsMoudel.startPost("/troubleshoottask/saveHiddenGovern", data, true).then(res => {
			const thisTroubleshootPlan = { ...that.cacheData};
			thisTroubleshootPlan.checkStandardVos[index].taskHiddenDangerVo = res.body.data;
			thisTroubleshootPlan.hiddenGovernNum= res.body.data.manage;
			thisTroubleshootPlan.taskHiddenDangerVo = res.body.data;
			that.callBack(thisTroubleshootPlan);
		})
	},

	modalCancle: function() {
		this.showModal = false;
		this.operaHiddenData = {
			taskHiddenDangerVo: {
				pass: 0
			}
		};
	}


}
root.watch = {
	cacheData: function(newCacheData, oldCacheData) {
		if (newCacheData.employeeVos) {
			newCacheData.employeeVos.forEach((item, index) => {
				if (index === 0) {
					this.employeeNames = item.nickname;
				} else {
					this.employeeNames = this.employeeNames + "," + item.nickname;
				}
			});
		}
		this.imagesBase64=[];
		if(newCacheData.images){
			this.imagesBase64=eval(newCacheData.images);
		}
	}
}

FactoryComponents.initComponent(root);
